/* Utils */
import _ from 'lodash'

export const taggedList  = (lists, tags) => {
  let newlists = lists
  if (tags.length) {
    newlists = {}
    for (const key in lists) {
      const item = lists[key]
      if(item.tags) {
        var found = true
        for(var i=0; i<tags.length; i++) {
          if (item.tags.indexOf(tags[i]) < 0) {
            found = false
            break;
          }
        }
        if (found) newlists[key] = item
      }
    }
  }
  return newlists
}

export const extractTagsAndFilter = (filter) => {
  let tags = filter.match(/#[a-zA-Z0-9]+/ig) || []
  for(var i = 0; i<tags.length; i++) {
    filter = filter.replace(tags[i],"")
    tags[i] = tags[i].replace("#", "")
  }
  filter = filter.replace(/^ +/,"")
  return {filter, tags}
}

export const filterList  = (lists, filter, fields) => {
  let newlists = lists
  if (filter !== "") {
    newlists = {}
    for (const key in lists) {
      const item = lists[key]
      try {
        const regX = new RegExp(filter.toString(), "i")
        for(var i=0; i<fields.length; i++) {
          let field = fields[i]
          if (typeof field === "array") field = field.join(" ")
          if (regX.test(item[field])) newlists[key] = item
        }
      } catch (e) {
        if (item[field].indexOf(filter)!=-1)
          newlists[key] = item
      }
    }
  }
  return newlists
}

export const sortList = (lists, key) => {
  return _.sortBy(
    _.cloneDeep(lists),
    [
      function(o) {
        if(_.isString(o[key])) return o[key].toLocaleLowerCase()
        return o[key]
      }
    ]
  )
}

export const filterAndSort = (lists, filter) => {
  let newlists = lists
  if (filter !== "") {
    newlists = {}
    for (const key in lists) {
      const item = lists[key]
      try {
        const regX = new RegExp(filter.toString(), "i")
        if (regX.test(item.name))
          newlists[key] = item
      } catch (e) {
        if (item.name.indexOf(filter)!=-1)
          newlists[key] = item
      }
    }
  }
  return _.sortBy(
    _.map(
      _.cloneDeep(newlists),
      (o, key) => {
        o.uuid = key
        o.sort = o.name.toLocaleLowerCase()
        return o
      }
    ),
    ["sort"]
  )
}



// WEBPACK FOOTER //
// ./src/app/util/list.js